// extracted by mini-css-extract-plugin
export default {"card":"CardMinor-module--card--31ee1","content":"CardMinor-module--content--32e4c"};